import type { Component } from "solid-js";
import type { IconProps } from "./types";

const ProcessIcon: Component<IconProps> = (props) => {
  const size = props.size || 16;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      width={size}
      height={size}
      class={props.class}
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M4.5 12a7.5 7.5 0 0 0 15 0m-15 0a7.5 7.5 0 1 1 15 0m-15 0H3m16.5 0H21m-1.5 0H12m-8.457 3.077 1.41-.513m14.095-5.13 1.41-.513M5.106 17.785l1.15-.964m11.49-9.642 1.149-.964M7.501 19.795l.75-1.3m7.5-12.99.75-1.3m-6.063 16.658.26-1.477m2.605-14.772.26-1.477m0 17.726-.26-1.477M10.698 4.614l-.26-1.477M16.5 19.794l-.75-1.299M7.5 4.205 12 12m8.457 3.077-1.41-.513m-14.095-5.13-1.41-.513M18.894 17.785l-1.149-.964m-11.49-9.642-1.15-.964M7.501 19.795 12 12m5.5 7.794L12 12m-4.502 7.794L12 12m-4.5-7.205L12 12M16.5 4.205 12 12m4.457 8.077L12 12"
      />
    </svg>
  );
};

export default ProcessIcon;
